export const DEFAULT_UPLOAD_ENDPOINT_URL = '/ajax/files/attachTemporary.php';
export const DEFAULT_UPLOAD_NAME = 'upload';
export const UPLOAD_INFO_URL = '/files/post_upload_url';
